import React, { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RatingItemType } from 'models/MessageType'

import StarsRating from './StarsRating'
import ScoresRating from './ScoresRating'
import {
  RatingContainer,
  RatingList
} from './Rating.styles'

enum RatingTypes {
  STAR_RATING = 'star-rating',
  NPS_SCORE = 'nps-score'
}

const RatingType = {
  [RatingTypes.STAR_RATING]: StarsRating,
  [RatingTypes.NPS_SCORE]: ScoresRating
}

interface Props {
  items: RatingItemType[]
  type: string
  rating: number
  setRating: (props: number) => void
  onRatingSelect: (props: RatingItemType) => void
  isDisabled: boolean
}

const Rating: FC<Props> = ({
  items,
  type,
  rating,
  setRating,
  onRatingSelect,
  isDisabled
}) => {
  const { t } = useTranslation()
  const [ratingItem, setRatingItem] = useState(null)
  const CurrentRatingType = RatingType[type]
  const isScoreType = useMemo(() => type === RatingTypes.NPS_SCORE, [type])
  const listAriaLabel = useMemo(() => isScoreType ? 'score_rating_list' : 'star_rating_list', [isScoreType])

  const onClickHandler = (ratingItem: RatingItemType) => {
    if (isDisabled) return
    const starNumber = ratingItem.scoreNumber

    setRating(starNumber)
    setRatingItem(ratingItem)
    if (starNumber === rating) {
      setRating(-1)
      setRatingItem(null)
    }
  }

  useEffect(() => {
    onRatingSelect(ratingItem)
  }, [onRatingSelect, ratingItem])

  return (
    <RatingContainer>
      <RatingList
        isScoreType={isScoreType}
        aria-label={t(listAriaLabel)}
      >
        {items.map(item => (
          <CurrentRatingType
            key={item.scoreNumber}
            item={item}
            isDisabled={isDisabled}
            rating={rating}
            onClickHandler={onClickHandler}
          />
        ))}
      </RatingList>
    </RatingContainer>
  )
}

export default Rating
